import { cn } from "@/src/shared/utils/mergeTwClasses";
import { Step, StepLabel, Stepper } from "@mui/material";
import { FC } from "react";
import { StepperProps } from "../lib/type";
import { MobileStepIcon } from "./MobileStepIcon";

export const MobileStepper: FC<StepperProps> = ({
    steps,
    stepperProps,
    stepProps,
    stepLabelProps,
    activeStep = 0,
    percent = 0,
}) => {
    return (
        <Stepper
            activeStep={activeStep}
            connector={null}
            className={cn(`hidden max-mdPlus:flex`, stepperProps?.className)}
            {...stepperProps}
        >
            {steps.map((_, index) => (
                <Step key={index} {...stepProps}>
                    <StepLabel
                        className={cn(`block`, stepLabelProps?.className)}
                        StepIconComponent={(props) => {
                            return <MobileStepIcon {...props} stepNumber={index + 1} percent={percent} />
                        }}
                    />
                </Step>
            ))}
        </Stepper>
    );
};
